import React from "react"

export function Logout(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8094 2.30938L15.6469 6.14687C15.8719 6.37187 16 6.68125 16 7C16 7.31875 15.8719 7.62812 15.6469 7.85312L11.8094 11.6906C11.6094 11.8906 11.3406 12 11.0594 12C10.475 12 10 11.525 10 10.9406V9H6C5.44688 9 5 8.55313 5 8V6C5 5.44688 5.44688 5 6 5H10V3.05937C10 2.475 10.475 2 11.0594 2C11.3406 2 11.6094 2.1125 11.8094 2.30938ZM5 2H3C2.44688 2 2 2.44688 2 3V11C2 11.5531 2.44688 12 3 12H5C5.55312 12 6 12.4469 6 13C6 13.5531 5.55312 14 5 14H3C1.34375 14 0 12.6562 0 11V3C0 1.34375 1.34375 0 3 0H5C5.55312 0 6 0.446875 6 1C6 1.55313 5.55312 2 5 2Z"
        fill="#4F4F4F"
      />
    </svg>
  )
}
